import { render, staticRenderFns } from "./GraficStatistics.vue?vue&type=template&id=4661b512&scoped=true"
import script from "./GraficStatistics.vue?vue&type=script&lang=js"
export * from "./GraficStatistics.vue?vue&type=script&lang=js"
import style0 from "./GraficStatistics.vue?vue&type=style&index=0&id=4661b512&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4661b512",
  null
  
)

export default component.exports